// src/store/slices/availabilitySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Update user availability
export const updateUserAvailability = createAsyncThunk(
  "availability/updateUserAvailability",
  async ({ data, userId }, { rejectWithValue }) => {
    try {
      const response = await agent.post(`${API.LOAD_CUSTOMER}/updateUserAvailability/${userId}`, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const availabilitySlice = createSlice({
  name: "availability",
  initialState: {
    updateProfileData: {}, // your user profile data that contains current availability
    loading: false,
    error: null,
    successMessage: "",
  },
  reducers: {
    clearMessages(state) {
      state.successMessage = "";
      state.error = null;
    },
    setUpdateProfileData(state, action) {
      state.updateProfileData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUserAvailability.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = "";
      })
      .addCase(updateUserAvailability.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message || "Availability updated!";
        // Optionally update the profile data if API returns updated user
        if (action.payload.data) {
          state.updateProfileData = {
            ...state.updateProfileData,
            ...action.payload.data,
          };
        }
      })
      .addCase(updateUserAvailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update availability";
      });
  },
});

export const { clearMessages, setUpdateProfileData } = availabilitySlice.actions;
export default availabilitySlice.reducer;